import { gql } from '@apollo/client';

export const FETCH_STATEMENTS_FOR_REVIEW = gql`
  query fetchAccountStatementsForReview($input: FetchAccountStatementsInput!) {
    fetchAccountStatements(input: $input) {
      accountStatements {
        id
        state
        type
        account {
          id
          type
        }
        user {
          id
          firstName
          lastName
          entityName
          organization {
            name
          }
        }
      }
      totalCount
    }
  }
`;

export const FETCH_STATEMENT_IDS = gql`
  query fetchAccountStatements($input: FetchAccountStatementsInput!) {
    fetchAccountStatements(input: $input) {
      accountStatements {
        id
      }
      totalCount
    }
  }
`;

export const FETCH_ACCOUNT_STATEMENT = gql`
  query fetchAccountStatement($accountStatementId: ObjectID!) {
    fetchAccountStatement(accountStatementId: $accountStatementId) {
      accountStatement {
        id
        signedUrl
      }
    }
  }
`;

export const TRANSITION_ACCOUNT_STATEMENTS = gql`
  mutation transitionAccountStatements($input: TransitionAccountStatementsInput!) {
    transitionAccountStatements(input: $input) {
      message
    }
  }
`;
